import { render } from "./todoEdit.vue?vue&type=template&id=5f61b5f8&scoped=true"
import script from "./todoEdit.vue?vue&type=script&lang=js"
export * from "./todoEdit.vue?vue&type=script&lang=js"

import "./todoEdit.vue?vue&type=style&index=0&id=5f61b5f8&scoped=true&lang=scss"
import "./todoEdit.vue?vue&type=style&index=1&id=5f61b5f8&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f61b5f8"]])

export default __exports__